export class ProductTagService {
  private static readonly patterns = {
    discount: /%$/,
    lowStock: /poucas unidades/i,
    inStock: /pronta-entrega/i,
  }

  static isInStock(tag: string) {
    return this.patterns.inStock.test(tag)
  }

  static isDiscount(tag: string) {
    return this.patterns.discount.test(tag)
  }

  static isLowStock(tag: string) {
    return this.patterns.lowStock.test(tag)
  }

  static sortByPriority(tags: string[]) {
    const priorityList: RegExp[] = [this.patterns.discount, this.patterns.lowStock]

    const getPriority = (tag: string) => priorityList.findIndex((regex) => regex.test(tag))

    return tags.sort((a: string, b: string) => getPriority(b) - getPriority(a))
  }

  static filterHighlightsOnly(tags: string[]) {
    return tags.filter((tag) => this.isDiscount(tag) || this.isLowStock(tag))
  }

  static hasTagLowStock(tags: string[]): boolean {
    return tags.some((tag) => this.isLowStock(tag))
  }
}
